var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parallelBranch"},[(_vm.modelId===1)?_c('List',{attrs:{"params":_vm.listParams},on:{"bindDevice":_vm.bindDevice}}):_vm._e(),_vm._v(" "),(_vm.modelId===2)?_c('Bind',{attrs:{"row":_vm.row},on:{"closeBind":_vm.closeBind}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5b01f7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/boss/parallelBranch/index.vue
// module id = null
// module chunks = 